import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TextUtils } from "../../utils/text-utils";
import { IconBasedContentBox } from "../icon-based-content-box/icon-based-content-box";
import { FontAwesomeDuoToneStyle } from "../../fontawesome";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    actionLink: {
        color: theme.palette.primary.main
    }
}));

export const PhoneNumber = ({
    value
}) => {
    const classes = useStyles();

    const getFormattedPhoneNumber = (phoneNumber) => {
        if (phoneNumber == null)
            return phoneNumber;

        return phoneNumber.startsWith('+') ? phoneNumber : `+${phoneNumber}`;
    };

    return !TextUtils.isNullOrWhiteSpace(value) ?
        <IconBasedContentBox icon={<FontAwesomeIcon icon={["fad", "phone"]} size="lg" style={FontAwesomeDuoToneStyle} />}>
            <a href={`tel:${getFormattedPhoneNumber(value)}`} className={classes.actionLink}>{getFormattedPhoneNumber(value)}</a>
        </IconBasedContentBox> : null;
}